import React, { useState, useEffect } from "react";
import HPageContainer from "../../../hcomponents/HPageContainer";
import HHeader from "../../../hcomponents/HHeader";
import OccupancyRateCard from "./components/OccupancyRateCard";
import TotalRevenueCard from "./components/TotalRevenueCard";
import SpaceStatisticsCard from "./components/SpaceStatisticsCard";
import spaceManagementService from "../../../services/host-apiServices/spaceManagementService";
import logger from "../../../utils/logger";


const HostAnalytics = () => {
  const [bookingStatsData, setBookingStatsData] = useState(null);
  const [bookingStatsLoading, setBookingStatsLoading] = useState(false);
  const [spaceStatsData, setSpaceStatsData] = useState(null);
  const [spaceStatsLoading, setSpaceStatsLoading] = useState(false);

  // Fetch booking statistics from API
  const fetchBookingStatistics = async () => {
    try {
      setBookingStatsLoading(true);
      const year = new Date().getFullYear();
      const response = await spaceManagementService.getBookingStatistics(year);

      if (response.data) {
        setBookingStatsData(response.data);
      }
    } catch (error) {
      logger.error("Error fetching booking statistics:", error);
      setBookingStatsData(null);
    } finally {
      setBookingStatsLoading(false);
    }
  };

  // Fetch space statistics from API
  const fetchSpaceStatistics = async () => {
    try {
      setSpaceStatsLoading(true);
      const response = await spaceManagementService.getSpaceStatistics();

      if (response.data) {
        setSpaceStatsData(response.data);
      }
    } catch (error) {
      logger.error("Error fetching space statistics:", error);
      setSpaceStatsData(null);
    } finally {
      setSpaceStatsLoading(false);
    }
  };

  useEffect(() => {
    fetchBookingStatistics();
    fetchSpaceStatistics();
  }, []);

  return (
    <HPageContainer>
      <HHeader />

      <div className="p-6">
        <div className="space-y-6">
          {/* Top Row - Main Metrics */}
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
            <OccupancyRateCard
              className="lg:col-span-3"
              data={
                bookingStatsData
                  ? {
                      totalOccupancyRate: Math.round(bookingStatsData.percentageOccupancyRate * 100),
                      occupancyChange: `${bookingStatsData.occupancyChangeType === "increase" ? "+" : ""}${Math.abs(bookingStatsData.occupancyRateChange).toFixed(1)}%`,
                      isOccupancyPositive: bookingStatsData.occupancyChangeType === "increase",
                      rooms: [],
                      daysOfWeek: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
                      bookingStats: bookingStatsData,
                    }
                  : {}
              }
              loading={bookingStatsLoading}
            />
            <TotalRevenueCard className="lg:col-span-2" />
          </div>

          {/* Second Row - Space Statistics */}
          <SpaceStatisticsCard data={spaceStatsData} loading={spaceStatsLoading} />
        </div>
      </div>
    </HPageContainer>
  );
};

export default HostAnalytics;
